var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 370,
    viewBox: "0 0 528 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3127_4987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.167 2H31.9202C19.814 2 10 11.814 10 23.9202V330.08C10 342.186 19.814 352 31.9202 352H495.167C507.273 352 517.087 342.186 517.087 330.08V23.9202C517.087 11.814 507.273 2 495.167 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23.9202C10 11.814 19.814 2 31.9202 2H495.167C507.273 2 517.087 11.814 517.087 23.9202V49.5007H10V23.9202Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3127_4987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6114 33.0568C47.6468 33.0568 50.9182 29.7855 50.9182 25.7501C50.9182 21.7147 47.6468 18.4434 43.6114 18.4434C39.576 18.4434 36.3047 21.7147 36.3047 25.7501C36.3047 29.7855 39.576 33.0568 43.6114 33.0568Z",
    fill: "#FA5C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9161 33.0568C73.9515 33.0568 77.2228 29.7855 77.2228 25.7501C77.2228 21.7147 73.9515 18.4434 69.9161 18.4434C65.8807 18.4434 62.6094 21.7147 62.6094 25.7501C62.6094 29.7855 65.8807 33.0568 69.9161 33.0568Z",
    fill: "#FEBC2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2208 33.0568C100.256 33.0568 103.528 29.7855 103.528 25.7501C103.528 21.7147 100.256 18.4434 96.2208 18.4434C92.1854 18.4434 88.9141 21.7147 88.9141 25.7501C88.9141 29.7855 92.1854 33.0568 96.2208 33.0568Z",
    fill: "#29C740"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.245 86.0342H53.838C49.8026 86.0342 46.5312 89.3055 46.5312 93.3409V112.338C46.5312 116.374 49.8026 119.645 53.838 119.645H473.245C477.28 119.645 480.551 116.374 480.551 112.338V93.3409C480.551 89.3055 477.28 86.0342 473.245 86.0342Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 192.513V184.02L214.275 150.467H224.662L206.055 183.472V183.871H236.344V192.513H195.219ZM219.705 201.481V189.998L220.005 186.162V169.596H229.844V201.481H219.705ZM263.534 202.602C259.249 202.585 255.562 201.531 252.473 199.438C249.401 197.346 247.035 194.315 245.374 190.346C243.73 186.377 242.917 181.603 242.933 176.023C242.933 170.46 243.756 165.719 245.4 161.8C247.06 157.88 249.426 154.901 252.498 152.858C255.587 150.799 259.265 149.769 263.534 149.769C267.801 149.769 271.47 150.799 274.544 152.858C277.631 154.917 280.006 157.905 281.668 161.825C283.328 165.728 284.15 170.46 284.133 176.023C284.133 181.62 283.303 186.402 281.643 190.371C279.999 194.34 277.64 197.37 274.568 199.463C271.495 201.556 267.817 202.602 263.534 202.602ZM263.534 193.659C266.457 193.659 268.789 192.19 270.532 189.25C272.277 186.311 273.139 181.902 273.123 176.023C273.123 172.153 272.724 168.933 271.928 166.359C271.147 163.784 270.034 161.85 268.59 160.555C267.162 159.26 265.476 158.611 263.534 158.611C260.627 158.611 258.302 160.065 256.559 162.97C254.815 165.877 253.934 170.227 253.918 176.023C253.918 179.942 254.308 183.214 255.089 185.838C255.887 188.445 257.007 190.404 258.451 191.717C259.897 193.011 261.59 193.659 263.534 193.659ZM291.052 192.513V184.02L310.107 150.467H320.494L301.887 183.472V183.871H332.178V192.513H291.052ZM315.537 201.481V189.998L315.837 186.162V169.596H325.676V201.481H315.537Z",
    fill: "#0165F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.871 233.631H53.838C49.8026 233.631 46.5312 236.902 46.5312 240.938V259.935C46.5312 263.971 49.8026 267.242 53.838 267.242H392.871C396.906 267.242 400.177 263.971 400.177 259.935V240.938C400.177 236.902 396.906 233.631 392.871 233.631Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.668 281.855H53.838C49.8026 281.855 46.5312 285.127 46.5312 289.162V308.16C46.5312 312.195 49.8026 315.466 53.838 315.466H173.668C177.704 315.466 180.975 312.195 180.975 308.16V289.162C180.975 285.127 177.704 281.855 173.668 281.855Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3127_4987",
    x: 0,
    y: 0,
    width: 527.086,
    height: 370,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.634822 0 0 0 0 0.634822 0 0 0 0 0.634822 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3127_4987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3127_4987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3127_4987",
    x: 36.3047,
    y: 18.4434,
    width: 67.2266,
    height: 16.6133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3127_4987"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture404);
export default __webpack_public_path__ + "static/media/picture_404.475a8f99f0104129b451b3af6086fb08.svg";
export { ForwardRef as ReactComponent };